import { BulkShipmentsModule } from '@/shared';

export default BulkShipmentsModule;
